import { SIZE } from 'assets/styles/ScreenSize';
import styled from 'styled-components/macro';
import { BREAKPOINTS } from 'utils/styles';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const HomePage = styled.div`
  width: 100%;
  background: linear-gradient(
    180deg,
    #fafeff 0%,
    #a8c9e1 54.82%,
    #ecf1f1 84.37%,
    #ecf1f1 96.81%,
    #ecf1f1 100%
  );
  background-repeat: no-repeat;
  @media ${BREAKPOINTS.lg} {
    height: auto;
  }
  .viewed-section {
    ${FLEX_CONTAINER.FlexColumn}
    margin-top: 30px;

    @media (min-width: ${SIZE.mobile}) {
      margin-top: 50px;
      padding: 0 25px;
    }
    @media (min-width: ${SIZE.iphone}) {
      margin-top: 60px;
      padding: 0 40px;
    }
    @media (min-width: ${SIZE.tablet}) {
      margin-top: 70px;
      padding: 0 40px;
    }
    @media (min-width: ${SIZE.desktop}) {
      margin-top: 96px;
      padding: 0 131px;
    }
    @media (min-width: ${SIZE.bigDesktop}) {
      margin-top: 30px;
      padding: 0 190px;
    }

    .title {
      ${FONT_FAMILY.FontSemiBold}
      color: ${COLORS.mainColor};

      @media (min-width: ${SIZE.mobile}) {
        ${FONTS.font14}
        margin-bottom: 22px;
      }
      @media (min-width: ${SIZE.iphone}) {
        ${FONTS.font16}
        margin-bottom: 24px;
      }
      @media (min-width: ${SIZE.tablet}) {
        ${FONTS.font16}
      }
      @media (min-width: ${SIZE.desktop}) {
        ${FONTS.font20}
      }
      @media (min-width: ${SIZE.bigDesktop}) {
        ${FONTS.font24}
        margin-bottom: 30px;
      }
    }

    .view-card-wrapper {
      ${FLEX_CONTAINER.FlexCenterRow}
    }

    .view-card {
      ${FLEX_CONTAINER.FlexRow}
      background: rgba(248, 248, 248, 0.5);
      border-radius: 16px;
      height: auto;

      @media (min-width: ${SIZE.mobile}) {
        padding: 19px 18px;
        width: 270px;
        flex-direction: column;
        margin-bottom: 50px;
      }

      @media (min-width: ${SIZE.iphone}) {
        width: 364.54px;
        padding: 22px;
        margin-bottom: 60px;
      }

      @media (min-width: ${SIZE.tablet}) {
        width: 620px;
        padding: 40px 50px;
        margin-bottom: 70px;
      }

      @media (min-width: ${SIZE.desktop}) {
        width: 1015px;
        padding: 40px 60px;
        flex-direction: row;
        margin-bottom: 100px;
      }

      @media (min-width: ${SIZE.bigDesktop}) {
        width: 1515px;
        padding: 57px 124px;
        margin-bottom: 110px;
      }

      .place-image {
        object-fit: cover;
        border-radius: 10px;

        @media (min-width: ${SIZE.mobile}) {
          width: 235px;
          height: 130px;
          margin-bottom: 30px;
        }
        @media (min-width: ${SIZE.iphone}) {
          width: 319.59px;
          height: 184.94px;
          margin-bottom: 24px;
        }
        @media (min-width: ${SIZE.tablet}) {
          width: 520px;
          height: 260px;
        }
        @media (min-width: ${SIZE.desktop}) {
          margin-bottom: 0;
          margin-right: 34px;
          width: 405px;
          height: 485px;
        }
        @media (min-width: ${SIZE.bigDesktop}) {
          width: 566px;
          height: 468px;
          margin-right: 46px;
        }
      }

      .name-price-wrapper {
        ${FLEX_CONTAINER.FlexSpaceBetweenRow}
        width: 100%;

        .name {
          ${FONT_FAMILY.FontMedium}
          color: ${COLORS.blueBlack};

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font14}
            margin-bottom: 14px;
          }
          @media (min-width: ${SIZE.iphone}) {
            ${FONTS.font16}
          }
          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font20}
          }
          @media (min-width: ${SIZE.desktop}) {
            ${FONTS.font20}
            margin-bottom: 10px;
          }
          @media (min-width: ${SIZE.bigDesktop}) {
            ${FONTS.font24}
            margin-bottom: 14px;
          }
        }

        .price {
          ${FONT_FAMILY.FontBold}
          color: ${COLORS.blue};

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font16}
          }
          @media (min-width: ${SIZE.iphone}) {
            ${FONTS.font24}
          }
          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font28}
          }
          @media (min-width: ${SIZE.desktop}) {
            ${FONTS.font28}
          }
          @media (min-width: ${SIZE.bigDesktop}) {
            ${FONTS.font36}
          }
        }
      }

      .info-wrapper {
        ${FONT_FAMILY.FontMedium}
        ${FLEX_CONTAINER.FlexColumn}
        color: ${COLORS.mainColor};

        p {
          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font12}
            margin-top: 12px;
          }
          @media (min-width: ${SIZE.iphone}) {
            ${FONTS.font14}
            margin-top: 16px;
          }
          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font16}
            margin-top: 15px;
          }
          @media (min-width: ${SIZE.bigDesktop}) {
            margin-top: 12px;
          }
        }

        a {
          ${FONT_FAMILY.FontMedium}

          color: ${COLORS.mainColor};

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font12}
            margin-top: 12px;
          }

          @media (min-width: ${SIZE.iphone}) {
            ${FONTS.font14}
            margin-top: 16px;
          }

          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font16}
            margin-top: 15px;
          }

          @media (min-width: ${SIZE.desktop}) {
            margin-top: 16px;
          }

          @media (min-width: ${SIZE.bigDesktop}) {
            margin-top: 12px;
          }
        }
      }
    }
  }

  .hot-offers-card-rapper {
    width: 240px !important;
    margin: 0 8.5px;
  }
`;
